import React, { useState } from 'react';
import { useUserContext } from '../../Contexts/UserContext';
import Button from '../form-components/input/Button';
import { toast } from 'react-toastify';

interface FormErrors {
    name?: string;
    email?: string;
    message?: string;
}

const ComplaintForm = () => {
    const { userData } = useUserContext()
    const [formData, setFormData] = useState({
        name: userData.firstName + ' ' + userData.lastName ,
        email: userData.email,
        message: ''
    });
    const [isloading, setIsLoading] = useState(false)
    const [errors, setErrors] = useState<FormErrors>({});

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Form validation
    const validateForm = () => {
        const formErrors: FormErrors = {};
        if (!formData.name.trim()) formErrors.name = 'Name is required';
        if (!formData.email.trim()) {
        formErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        formErrors.email = 'Invalid email address';
        }
        if (!formData.message.trim()) formErrors.message = 'Message is required';
        return formErrors;
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        const authToken = sessionStorage.getItem('token')
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length === 0) {
        console.log('Form Data:', formData);
            try {
            setIsLoading(true)

            const response = await fetch ('https://backend-kyw8.onrender.com/contact-message', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${authToken}`,
                },
                body: JSON.stringify( formData ),
            });
            if (response.ok) {
                toast.success('Message Sent!', {
                    position: 'top-center',
                });
            } else {
                toast.error('Message sending Failed, try again later!', {
                    position: 'top-center',
                });
            }
            } catch (error: any) {
                toast.error(error, {
                    position: 'top-center'
                })
            } finally {
                setIsLoading(false)
            }
        } else {
        setErrors(validationErrors);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="max-w-md mx-auto p-6 bg-white shadow-md rounded-md">
        <h2 className="form-header">Contact Us</h2>
        <div className="mb-4">
            <label className="block text-gray-700">Name:</label>
            <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full border rounded-md p-2"
            />
            {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
        </div>
        
        <div className="mb-4">
            <label className="block text-gray-700">Email:</label>
            <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full border rounded-md p-2"
            />
            {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
        </div>
        
        <div className="mb-4">
            <label className="block text-gray-700">Message:</label>
            <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="w-full border rounded-md p-2 h-24"
            ></textarea>
            {errors.message && <p className="text-red-500 text-sm">{errors.message}</p>}
        </div>
        <Button 
            buttonText='submit'
            type='submit'
            isLoading={isloading}
            disabled={isloading}
        />
        </form>
    );
};

export default ComplaintForm;
